module.exports = __webpack_public_path__ + "static/media/maintainance.a843b953.svg";